// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'

export const setLoading = createAsyncThunk('POSEntry/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('POSEntry/getData', async (params, { dispatch }) => {
    dispatch(setLoading({ getData: true }))
    const response = await axios.put('/SalesInvoices/GetCurrentActiveShift', { params })
    dispatch(setLoading({ getData: false }))
    return {
        params,
        data: response?.data,
    }
})

export const POSEntrySlice = createSlice({
    name: 'POSEntry',
    initialState: {
        data: {},
        totalRecords: 1,
        params: {},
        loadingState: { getData: false, getTypeData: false, getJournal: false }
        // allData: []
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getData.fulfilled, (state, action) => {
                state.data = action.payload.data.data??{message: "Not found"}
                state.totalRecords = action.payload.data.totalRecords
                state.params = action.payload.params
            })
            .addCase(setLoading.fulfilled, (state, action) => {
                state.loadingState = action.payload
            })
    }
})

export default POSEntrySlice.reducer
